import {AfterViewInit, Component, inject, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {StateConfigService} from "../../../../services/state/state-config.service";
import {Parameter} from '../../../../quality-api';
import {faChevronDown} from "@fortawesome/pro-solid-svg-icons";
import {initFlowbite} from "flowbite";
import {ProjectControllerService} from "../../../../api";
import {
  BicButtonComponent,
  BicDropdownElementComponent,
  BicInputComponent,
  BicPopupComponent,
  BicSelectComponent
} from "@buildinginformationcloud/bic-ui-components";


@Component({
  selector: 'app-qualityCheck-settings',
  templateUrl: './quality-settings.component.html',
  styleUrls: ['./quality-settings.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [

    ReactiveFormsModule,
    BicDropdownElementComponent,
    BicSelectComponent,
    BicInputComponent,
    BicButtonComponent,
    MatDialogClose,
    BicPopupComponent
  ]
})
export class QualitySettingsComponent implements OnInit, AfterViewInit, OnChanges {
  data = inject<{
    parameters: Parameter[];
  }>(MAT_DIALOG_DATA);
  stateConfigService = inject(StateConfigService);
  projectControllerService = inject(ProjectControllerService);
  private formBuilder = inject(UntypedFormBuilder);
  protected dialogRef = inject<MatDialogRef<QualitySettingsComponent>>(MatDialogRef);


  taskForm!: UntypedFormGroup;

  values = {};
  placeholder = {
    "arbeitshaltung": "z.B. Sitzen",
    "arbeitsschwere": "z.B. Leicht",
    "number_of_employees": " z.B. 10",
    "groundwater_level": "z.B. -2,50",
    "terrain_level": "z.B. 0,00",
    "freestanding": "ja / nein",
    "building_use": "z.B. Bürogebäude",
    "building_class": "z.B. Gebäudeklasse 1",
    "usage": "z.B. Bürogebäude"

  }

  saveSettings: boolean = false

  ngOnInit(): void {
    this.setupForm();
    this.values = JSON.parse(this.stateConfigService.selectedProject.qualitySettings ?? "{}");
    this.taskForm.patchValue(this.values);
  }
  ngAfterViewInit() {
    initFlowbite()
  }
  ngOnChanges(changes: SimpleChanges) {
    initFlowbite()
  }

  get parameters(): Parameter[] {
    return this.data.parameters ?? [];
  }

  setupForm() {
    const config: any = {};
    this.parameters.forEach(param => {
      if (param.value)
        if (param.value == 'usage') {
          config[param.value] = [this.stateConfigService.selectedProject.projectKind, Validators.required];
        } else {
          config[param.value] = ['', Validators.required];
        }
    });
    this.values = config
    this.taskForm = this.formBuilder.group(config);
  }

  check() {
    if(this.saveSettings){
      this.saveProjectSettings()
    }
    this.dialogRef.close(this.taskForm.value);
  }

  saveProjectSettings(){
    let project = this.stateConfigService.selectedProject
    project.qualitySettings = JSON.stringify({...this.values, ...this.taskForm.value})
    let settings = JSON.parse(project.qualitySettings)
    if('usage' in settings){
      project.projectKind = settings['usage' as keyof typeof settings]
    }

    this.projectControllerService.updateProject(project,this.stateConfigService.getProjectId()).subscribe(project=>{
        this.stateConfigService.selectedProject = project
      }
    )
  }

  setCheckbox(){
    this.saveSettings=!this.saveSettings
  }

  protected readonly Parameter = Parameter;
  protected readonly faChevronDown = faChevronDown;
}
